import React from "react";

export default function SectionHeading({ title, description, align = "left" }) {
  return (
    <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      <h2 className="text-display-md">{title}</h2>
      {description && <p className="mt-4 text-ink/70 leading-relaxed">{description}</p>}
    </div>
  );
}
